// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"84d4b3d6","732":"e1c96c60","977":"f1209ffc"}[chunkId] + ".chunk.js";
};